import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaTiktok, FaTwitter } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import logo from "../assets/images/logo.png";
import { FaMapMarkerAlt } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-top">

        <div className="footer-section">
          <img src={logo} alt="UN-BORDERS Logo" className="footer-logo" />
          <p className="footer-text">
            شركة UN-BORDERS للاستشارات الهندسية
            نعمل على تقديم حلول هندسية مبتكرة وعالية الجودة.
          </p>
        </div>

        <div className="footer-section">
          <h3>روابط سريعة</h3>
          <ul>
            <li><Link to="/">الرئيسية</Link></li>
            <li><Link to="/about">من نحن</Link></li>
            <li><Link to="/services">خدماتنا</Link></li>
            <li><Link to="/contact">تواصل معنا</Link></li>
            <li><Link to="/privacy-policy">سياسة الخصوصية</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>تواصل معنا</h3>

          {/* تعديل: رقم الهاتف الأول (قابلة للضغط) */}
          <a href="tel:+966509565618" className="contact-item footer-link" aria-label="رقم الهاتف السعودي">
            <FaPhoneAlt className="icon" />
            <span className="ltr-text">+966509565618</span>
          </a>

          {/* تعديل: رقم الهاتف الثاني (قابلة للضغط) */}
          <a href="tel:+201100012601" className="contact-item footer-link" aria-label="رقم الهاتف المصري">
            <FaPhoneAlt className="icon" />
            <span className="ltr-text">+201100012601</span>
          </a>

          {/* تعديل: البريد الإلكتروني (قابلة للضغط) */}
          <a href="mailto:1.unborders@gmail.com" className="contact-item footer-link" aria-label="البريد الإلكتروني">
            <MdEmail className="icon" />
            <span className="ltr-text">1.unborders@gmail.com</span>
          </a>

          {/* العنوان (غير قابل للضغط - لا يحتاج لتعديل) */}
          <div className="contact-item address">
            <div className="address-line">
              <FaMapMarkerAlt className="icon" />
              <span>مدينة كفر الشيخ - محافظة كفر الشيخ - مصر</span>
            </div>
            <div className="address-line">
              <FaMapMarkerAlt className="icon" />
              <span>القصيم - المملكة العربية السعودية</span>
            </div>
          </div>


        </div>

        <div className="footer-section">
          <h3>تابعنا  على</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/1.UNBORDERS/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/un.borders/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://x.com/UNBorders1" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://www.tiktok.com/@unborders1?_r=1&_t=ZS-91N70Fe6407" aria-label="TikTok"><FaTiktok /></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 UN-BORDERS Engineering Consultancy. جميع الحقوق محفوظة.</p>

        <div className="developer-row">
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/mohamed--gaber/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BzXbZWD%2F3QUOAxNo1%2FDKUDA%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-linkedin"></i>
            </a>
          </div>

          <span className="dev-text">Developed by Mohamed Ibrahim</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;